import { isErrorType } from "../guards";
import { ErrorType } from "../types";
export default function getFallbackMessage(type) {
    if (!isErrorType(type)) {
        return 'Невідома помилка';
    }
    switch (type) {
        case ErrorType.Request:
            return 'Помилка запиту';
        case ErrorType.NotAuthorized:
            return 'Потрібна авторизація';
        case ErrorType.AccessDenied:
            return 'У вас немає доступу до цього';
        case ErrorType.NotFound:
            return 'Не знайдено';
        case ErrorType.Server:
            return 'Помилка сервера';
        case ErrorType.Validation:
            return 'Помилка валідації';
        case ErrorType.Offline:
            return 'Сервер недоступний. Перевірте з\'єднання з інтернетом';
        case ErrorType.Maintenance:
            return 'Проводяться технічні роботи';
    }
}
//# sourceMappingURL=getFallbackMessage.js.map